// form test covid

let formTestCovidValidator = null;
let lang;

const formTestCovidInitValidator = function() {
    if (formTestCovidValidator == null) {
        if ($('#form-testcovid').length) {
            lang = 'EN';
        } else if ($('#form-testcovid-es').length) {
            lang = 'ES';
        }
        if ('EN' == lang) {
            formTestCovidValidator = $('#form-testcovid').validate({
                rules: {
                    testcovid_user: {
                        required: true
                    },
                    testcovid_password: {
                        required: true
                    }
                },
                messages: {
                    testcovid_user: {
                        required: 'Write your username, please'
                    },
                    testcovid_password: {
                        required: 'Write your password, please'
                    }
                },
                errorElement: 'span',
                errorClass: 'error',
                errorPlacement: function (error, element) {
                    error.insertAfter(element);
                },
                success: function (label, element) {
                    if ($(element).next('span')[0])
                        $(element).next('span')[0].remove();
                },
                highlight: function (element, errorClass, validClass) {
                    $(element).closest('.form-group').addClass('alert').addClass('alert-danger');
                },
                unhighlight: function (element, errorClass, validClass) {
                    $(element).closest('.form-group').removeClass('alert').removeClass('alert-danger');
                }
            });
        } else if ('ES' == lang) {
            formTestCovidValidator = $('#form-testcovid-es').validate({
                rules: {
                    testcovid_user: {
                        required: true
                    },
                    testcovid_password: {
                        required: true
                    }
                },
                messages: {
                    testcovid_user: {
                        required: 'Escriba su usuario, por favor'
                    },
                    testcovid_password: {
                        required: 'Escriba su contraseña, por favor'
                    }
                },
                errorElement: 'span',
                errorClass: 'error',
                errorPlacement: function (error, element) {
                    error.insertAfter(element);
                },
                success: function (label, element) {
                    if ($(element).next('span')[0])
                        $(element).next('span')[0].remove();
                },
                highlight: function (element, errorClass, validClass) {
                    $(element).closest('.form-group').addClass('alert').addClass('alert-danger');
                },
                unhighlight: function (element, errorClass, validClass) {
                    $(element).closest('.form-group').removeClass('alert').removeClass('alert-danger');
                }
            });
        }
    }
};
const formTestCovidSend = function() {
    $('#testcovid-success').addClass('d-none');
    $('#testcovid-error').addClass('d-none');
    formTestCovidInitValidator();
    let url;
    if ('EN' == lang) {
        if (!$('#form-testcovid').valid()) {
            return false;
        }
        url = '/api/formulario/testcovid';
    } else if ('ES' == lang) {
        if (!$('#form-testcovid-es').valid()) {
            return false;
        }
        url = '/api/formulario/es/testcovid';
    }
    $('#btn-testcovid-send').addClass('d-none');
    $('#btn-testcovid-sending').removeClass('d-none');
    const payload = {
        user: $('#testcovid_user').val(),
        password: $('#testcovid_password').val()
    };
    $.ajax({
        headers: {
            Accept: 'application/json; charset=utf-8',
            'Content-Type': 'application/json; charset=utf-8'
        },
        type: 'POST',
        url: url,
        data: JSON.stringify(payload),
        dataType: 'json',
        success: function (data, status, jqXHR) {
            $('#btn-testcovid-send').removeClass('d-none');
            $('#btn-testcovid-sending').addClass('d-none');
            if ('OK' == data.status) {
                $('#testcovid_user,#testcovid_password').val('');
                $('#user').val(payload.user);
                $('#password').val(payload.password);
                $('#form-testcovid-download').submit();
                /*
                var frame = document.createElement('iframe');
                frame.style.display = 'none';
                frame.setAttribute('src', '/api/formulario/testcovid/download');
                document.body.appendChild(frame);
                */
            } else {
                $('#testcovid-error').html(data.message).removeClass('d-none');
            }
        },
        error: function (jqXHR, status) {
            $('#btn-testcovid-send').removeClass('d-none');
            $('#btn-testcovid-sending').addClass('d-none');
            if ('EN' == lang)
                $('#testcovid-error').html('Your message has not been delivered, please try again.<br />If the problem persists please contact us at: info@helicopterossanitarios.com<br />Sorry for the inconvenience.').removeClass('d-none');
            else if ('ES' == lang)
                $('#testcovid-error').html('Su mensaje no ha podido ser entregado, por favor inténtelo más tarde.<br />Si el problema persiste, póngase en contacto con nosotros en: info@helicopterossanitarios.com<br />Disculpe las molestias.').removeClass('d-none');
        }
    });
    return false;
};
  
window.formTestCovidSend = formTestCovidSend;

